module.exports = __webpack_public_path__ + "grass-instance-0.62e5ff3cadc8282b26f795bf9aedd7ad.png";